import {
  View,
  Text,
  ScrollView,
  TouchableOpacity,
  TouchableWithoutFeedback,
} from "react-native";
import React, { useEffect, useRef, useState } from "react";
import {
  StackActions,
  useFocusEffect,
  useNavigation,
} from "@react-navigation/native";
import { navigateToScreen } from "../../../utility/NavigationHelper";
import {
  useDeviceSize,
  CreateResponsiveStyle,
  DEVICE_SIZES,
} from "rn-responsive-styles";
import { AppColors } from "../../../utility/AppColors";
import { AppFontStyle } from "../../../styles/AppFontStyle";
import { AppImages } from "../../../utility/AppImages";
import {
  getLoginData,
  getUserBio,
  removeSessionId,
  storeUserBio,
} from "../../../utility/AppStoreData";
import { AppScreens } from "../../Utility/AppScreens";
import AddEventDetails from "./CreateEvents/AddEventDetails";
import CompetitorsModal from "./CreateEvents/CompetitorsModal";
import { base_url, BeltImages, endpoints } from "../../../Api/configs";
import { toast } from "react-toastify";
import BuyBeltaModal from "./BeltScreens/BuyBeltaModal";
import CornfirmPurchaseBeltModal from "./BeltScreens/CornfirmPurchaseBeltModal";
import BeltPurchaseSuccessModal from "./BeltScreens/BeltPurchaseSuccessModal";
import SaleBeltModal from "./SaleBeltScreens/SaleBeltModal";
import VerificationModal from "./VerificationModal";
import PurchaseSuccess, { enumPurchaseSuccess } from "./PurchaseSuccess";
import PaymentScreen from "./BeltScreens/PaymentScreen";
import * as WebBrowser from "expo-web-browser";
import Separator from "../../../Components/Separator";
import { getUserProfile } from "../../../services/authAPI";
import { handleApiError } from "../../../services/errorHandler";
import {
  fetchPaymentBeltExchange,
  fetchPurchaseSuccess,
  fetchUserBalance,
} from "../../../services/profileAPI";
import { allRankingAPI } from "../../../services/eventsAPI";
import RedeemCreditsModal from "../../../Components/profile-common-components/RedeemCreditsModal";
import PurchaseSessionSuccessModal from "./PurchaseSessionSuccessModal";
import { useAuthProvider } from "../../../context/AuthContext";
import Header from "./Common/Header";
import UserDetail from "../../../Components/profile-common-components/UserDetail";
import MyBelts from "../../../Components/profile-common-components/MyBelts";
import MyGamesStatus from "../../../Components/profile-common-components/MyGamesStatus";
import MyGames from "../../../Components/profile-common-components/MyGames";
import UserBalance from "../../../Components/profile-common-components/UserBalance";
import UserCredits from "../../../Components/profile-common-components/UserCredits";
// import TotalTicketSold from "../../../Components/profile-common-components/TotalTicketSold";
import RankingTable from "../../../Components/profile-common-components/RankingTable";
import FinalWarning from "./SaleBeltScreens/FinalWarning";
import AddSocialLink from "./SaleBeltScreens/AddSocialLink";
import { useTooltips } from "../../../context/WalkthroughContext";
import UserProfileWalkthrough from "../../../Components/walk-through-common-components/profileTooltips/UserProfileWalkthrough";
import GamesWalkthrough from "../../../Components/walk-through-common-components/profileTooltips/GamesWalkthrough";
import ProWalkthrough from "../../../Components/walk-through-common-components/profileTooltips/ProWalkthrough";
import { ScreenBGGradientView } from "../../../common/CommonView";

const MyProfileWebScreen = ({ route }) => {
  const navigation = useNavigation();
  const styles = useStyles();
  const deviceSize = useDeviceSize();
  const [showLoader, setShowLoader] = useState(false);
  const [userData, setUserData] = useState(null);
  const [txtBio, setTxtBio] = useState("");
  const [createEvent, setCreateEvent] = useState(false);
  const [competitorModel, setCompetitorModel] = useState(false);
  const [searchEvent, setSearchEvent] = useState("");
  const [arrBeltMedalType, setArrBeltMedalType] = useState([
    {
      id: 0,
      value: 0,
      image: AppImages.icCoinBelt,
      isAvailableAmountSelected: 1,
      title: "Coin",
      isSelected: false,
      currentPrize: 0,
      sellPrice: 0,
      locked: true,
      purchaseLock: true,
      purchasedBeltAmount: 0,
      width:
        deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
          ? 69
          : 77,
      height: 69,
      popupIconWidth: 58,
    },
    {
      id: 1,
      image: AppImages.icBronzeBelt,
      title: "Bronze",
      isSelected: true,
      currentPrize: 0,
      value: 0,
      sellPrice: 0,
      purchaseLock: false,
      purchaseToken: 0,
      purchasedBeltAmount: 0,
      width: 99,
      height: 79,
      popupIconWidth: 73,
    },
    {
      id: 2,
      image: AppImages.icSilverBelt,
      title: "Silver",
      isSelected: false,
      currentPrize: 0,
      value: 0,
      sellPrice: 0,
      purchaseLock: true,
      purchaseToken: 0,
      purchasedBeltAmount: 0,
      width: 99,
      height: 79,
      popupIconWidth: 73,
    },
    {
      id: 3,
      image: AppImages.icGoldBelt,
      title: "Gold",
      isSelected: false,
      currentPrize: 0,
      value: 0,
      sellPrice: 0,
      purchaseLock: true,
      purchaseToken: 0,
      purchasedBeltAmount: 0,
      width: 99,
      height: 79,
      popupIconWidth: 73,
    },
    {
      id: 4,
      image: AppImages.icPlatinumBelt,
      title: "Platinum",
      isSelected: false,
      currentPrize: 0,
      value: 0,
      sellPrice: 0,
      purchaseLock: true,
      purchaseToken: 0,
      purchasedBeltAmount: 0,
      width: 99,
      height: 79,
      popupIconWidth: 73,
    },
  ]);

  const [numberOfBelts, setNumberOfBelts] = useState("0");
  const [apiData, setApiData] = useState({});
  const [accessToken, setAccessToken] = useState("");
  const [refreshAPICall, setRefreshAPICall] = useState(false);
  const [sessionId, setSessionId] = useState(route?.params?.session_id || "");

  const [buyBeltaModal, setBuyBeltaModal] = useState(false);
  const [showPaymentScreen, setShowPaymentScreen] = useState(false);
  const [cornfirmPurchaseBeltModal, setCornfirmPurchaseBeltModal] =
    useState(false);
  const [beltPurchaseSuccessModal, setBeltPurchaseSuccessModal] =
    useState(false);
  const [saleBeltModal, setSaleBeltModal] = useState(false);
  const [redeemBalance, setRedeemBalance] = useState(false);
  const [saleBeltData, setSaleBeltData] = useState(null);
  const [showVerification, setShowVerification] = useState(false);
  const [showPurchaseSuccess, setShowPurchaseSuccess] = useState(false);
  const [userBalanceData, setUserBalanceData] = useState(null);
  const [userProfileData, setUserProfileData] = useState(null);
  const [rankingData, setRankingData] = useState(null);
  const [finalWarningPopup, setFinalWarningPopup] = useState(false);
  const [addLinkPopup, setAddLinkPopup] = useState(false);
  const [links, setLinks] = useState({
    instagram: "",
    youtube: "",
    twitch: "",
    discord: "",
    x: "",
    linkedIn: "",
    facebook: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const handleLinkChange = (platform, text) => {
    setLinks((prevLinks) => ({
      ...prevLinks,
      [platform]: text,
    }));
  };

  // const handleUpdateLinks = (updatedLinks) => {
  //   setLinks((prevLinks) => ({
  //     ...prevLinks,
  //     ...updatedLinks,
  //   }));
  //   callUpdateLinksAPI(updatedLinks);
  // };

  const handleUpdateLinks = (updatedLinks, callback) => {
    setLinks((prevLinks) => ({
      ...prevLinks,
      ...updatedLinks,
    }));

    callUpdateLinksAPI(updatedLinks, callback);
  };

  useFocusEffect(
    React.useCallback(() => {
      // This will run every time the screen comes into focus
      setRefreshAPICall(true);
    }, [])
  );

  useEffect(() => {
    getLoginUserData();
  }, []);

  useEffect(() => {
    if (refreshAPICall) {
      reloadAPIs();
      setRefreshAPICall(false);
    }
  }, [refreshAPICall]);

  useEffect(() => {
    if (accessToken !== "") {
      reloadAPIs();
    }
  }, [accessToken]);
  const allRanking = async () => {
    setShowLoader(true);
    try {
      const response = await allRankingAPI();
      if (response.statusCode === 200) {
        setRankingData(response.body.rankingResult);
      }
    } catch (error) {
      setShowLoader(false);
      toast.error(error.message);
    }
  };
  const checkUserBalanceAPI = async () => {
    setShowLoader(true);

    try {
      const data = await fetchUserBalance(accessToken);

      const responseBody =
        typeof data.body === "string" ? JSON.parse(data.body) : data.body;
      if (data) {
        setUserBalanceData(responseBody);
        const belts = responseBody?.belts;

        const arr = [...arrBeltMedalType];

        // Only process belts if they exist
        if (belts) {
          arr.map((item) => {
            if (item.title === "Bronze") item.value = Number(belts.bronze || 0);
            else if (item.title === "Silver")
              item.value = Number(belts.silver || 0);
            else if (item.title === "Gold")
              item.value = Number(belts.gold || 0);
            else if (item.title === "Platinum")
              item.value = Number(belts.platinum || 0);
          });
        }
        setArrBeltMedalType(arr);
      } else {
        handleApiError(data.statusCode, data.error);
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setShowLoader(false);
    }
  };

  const beltPurchaseRates = {
    Bronze: 550,
    Silver: 5500,
    Gold: 55000,
    Platinum: 550000,
  };

  const creditRates = {
    Bronze: 500,
    Silver: 5000,
    Gold: 50000,
    Platinum: 500000,
  };

  const paymentBeltExchangeAPI = async () => {
    setShowLoader(true);

    try {
      const response = await fetchPaymentBeltExchange(accessToken);
      setShowLoader(false);
      if (response.statusCode === 200) {
        const arr = [...arrBeltMedalType];
        arr.map((item) => {
          if (item.title === "Bronze") {
            item.currentPrize = beltPurchaseRates.Bronze;
            item.sellPrice = Number(response.sellRates.bronze);
          } else if (item.title === "Silver") {
            item.currentPrize = beltPurchaseRates.Silver;
            item.sellPrice = Number(response.sellRates.silver);
          } else if (item.title === "Gold") {
            item.currentPrize = beltPurchaseRates.Gold;
            item.sellPrice = Number(response.sellRates.gold);
          } else if (item.title === "Platinum") {
            item.currentPrize = beltPurchaseRates.Platinum;
            item.sellPrice = Number(response.sellRates.platinum);
          }
        });
        setArrBeltMedalType(arr);
      } else {
        handleApiError(response.statusCode, response.error);
      }
    } catch (error) {
      setShowLoader(false);
      toast.error(error.message);
    }
  };
  function reloadAPIs() {
    getLoginUserData();
    checkUserBalanceAPI();
    paymentBeltExchangeAPI();
    allRanking();
  }

  // const callUpdateLinksAPI = (updatedLinks) => {
  //   if (!links || Object.values(links).every((link) => !link)) {
  //     toast.error("Please add Links");
  //     return;
  //   }

  const callUpdateLinksAPI = (updatedLinks, callback) => {
    if (!updatedLinks || Object.values(updatedLinks).every((link) => !link)) {
      toast.error("Please add Links");
      callback && callback(); // Reset isSaving if no valid input
      return;
    }

    setShowLoader(true);

    const params = {
      username: userData.username,
      accessToken: accessToken,
      socialLinks: {},
    };

    for (const [key, value] of Object.entries(updatedLinks)) {
      if (value) {
        params.socialLinks[`${key}Link`] = value;
      }
    }

    fetch(base_url + endpoints.auth.updateProfile, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        body: params,
      }),
    })
      .then((response) => response.json())
      .then((json) => {
        if (json.statusCode === 200) {
          toast.success("Social links updated successfully.");
          setAddLinkPopup(false);
        } else {
          toast.error(json.body.error);
        }
        setShowLoader(false);
      })
      .catch((error) => {
        setShowLoader(false);
      });
  };

  //   fetch(base_url + endpoints.auth.updateProfile, {
  //     method: "PATCH",
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     body: JSON.stringify({ body: params }),
  //   })
  //     .then((response) => response.json())
  //     .then((json) => {
  //       setShowLoader(false);
  //       callback && callback(); // Reset isSaving when API call is complete

  //       if (json.statusCode === 200) {
  //         toast.success("Social links updated successfully.");
  //         setAddLinkPopup(false);
  //       } else {
  //         toast.error(json.body.error);
  //       }
  //     })
  //     .catch((error) => {
  //       setShowLoader(false);
  //       callback && callback(); // Reset isSaving on error
  //       toast.error("Failed to update links.");
  //     });
  // };

  useEffect(() => {
    const logCurrentUrl = () => {
      const currentUrl = new URL(window.location.href);
      if (currentUrl.searchParams.has("session_id")) {
        const sessionId = currentUrl.searchParams.get("session_id");
      }
    };

    logCurrentUrl();

    window.onpopstate = logCurrentUrl;

    return () => {
      window.onpopstate = null;
    };
  }, []);
  const getLoginUserData = async () => {
    try {
      const data = await getLoginData();
      const getBioData = await getUserBio();

      if (getBioData != null) {
        setTxtBio(getBioData);
      }

      if (data != null) {
        setUserData(data);

        setAccessToken(data.AccessToken);
        await userProfileAPI(data.AccessToken);
      }
    } catch (error) {
      toast.error("Failed to fetch user data");
    }
  };
  const [result, setResult] = useState(null);

  const userProfileAPI = async (AccessToken?: string) => {
    // setShowLoader(true);
    setIsLoading(true);
    try {
      const data = await getUserProfile(AccessToken);
      const responseBody =
        typeof data.body === "string" ? JSON.parse(data.body) : data.body;

      // setShowLoader(false);
      if (data.statusCode === 200) {
        setUserProfileData(responseBody);
        setTxtBio(responseBody.bio);
        setLinks({
          instagram: responseBody.socialLinks.instagramLink || "",
          youtube: responseBody.socialLinks.youtubeLink || "",
          twitch: responseBody.socialLinks.twitchLink || "",
          discord: responseBody.socialLinks.discordLink || "",
          x: responseBody.socialLinks.xLink || "",
          linkedIn: responseBody.socialLinks.linkedInLink || "",
          facebook: responseBody.socialLinks.facebookLink || "",
        });
      } else if (data.statusCode == 400) {
        toast.error("Bad Request");
      } else if (data.statusCode > 400 && data.statusCode < 420) {
        toast.error("Unauthorized");
      } else if (data.statusCode >= 500) {
        toast.error("Internal Server Error");
      }
    } catch (error) {
      // setShowLoader(false);
      toast.error(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const filterRankingData = () => {
    if (!searchEvent) {
      return rankingData;
    }

    const searchTerm = searchEvent.toLowerCase();
    return rankingData.filter(
      (item) =>
        item.rank.toString().includes(searchTerm) ||
        item.userId.toLowerCase().includes(searchTerm) ||
        item.beltsWon.toString().includes(searchTerm) ||
        item.totalViews.toString().includes(searchTerm) ||
        item.giftsReceived.toString().includes(searchTerm) ||
        item.totalWinning.toString().includes(searchTerm)
    );
  };

  const filteredRankingData = filterRankingData();
  const handleSearchInput = (input) => {
    // Regular expression to allow only alphanumeric characters (letters and numbers)
    const alphanumericRegex = /^[a-zA-Z0-9]*$/;
    if (alphanumericRegex.test(input)) {
      setSearchEvent(input); // Only update state if the input is valid
    } else {
      toast.error("Only letters and numbers are allowed.", {});
    }
  };
  const { isActiveSubscriptionFound } = useAuthProvider();

  const scrollViewRef = useRef(null);

  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [userTokens, setUserTokens] = useState("");
  const { eventID } = route.params || {};

  useEffect(() => {
    getLoginUserData();
  }, []);

  useEffect(() => {
    const handleSessionId = async () => {
      if (route.params?.session_id) {
        setSessionId(route.params?.session_id);
        try {
          const data = await getLoginData();
          const UserAccessToken = data?.AccessToken;

          if (UserAccessToken) {
            setShowSuccessModal(true);
            await callPurchaseSuccessApi(
              route.params?.session_id,
              UserAccessToken
            );
          } else {
            console.error("Access token not found.");
          }
        } catch (error) {
          console.error("Error handling session ID:", error.message);
        }
      }
    };

    handleSessionId();
  }, [route.params]);

  async function callPurchaseSuccessApi(session_id, accessToken) {
    setShowLoader(true);
    removeSessionId();
    try {
      const data = await fetchPurchaseSuccess(session_id, accessToken);
      setShowLoader(false);
      if (data) {
        setUserTokens(data.tokens.toString());
      } else {
        toast.error(
          data.error || "An error occurred during purchase success processing"
        );
      }
    } catch (error) {
      setShowLoader(false);
      toast.error(error.message);
    }
  }
  const [activeTab, setActiveTab] = useState(0);
  const tabTitles = ["Profile", "Belts", "Stats", "Balance", "Rank"];

  const [showTotalTicketInfo, setShowTotalTicketInfo] = useState(false);
  const [totalShowInfo, setTotalShowInfo] = useState(false);
  const [coinsShowInfo, setCoinsShowInfo] = useState(false);
  const [totalBalanceShowInfo, setTotalBalanceShowInfo] = useState(false);
  const [availableCreditsShowInfo, setAvailableCreditsShowInfo] =
    useState(false);

  const closeTooltips = () => {
    if (showTotalTicketInfo) setShowTotalTicketInfo(false);
    if (totalShowInfo) setTotalShowInfo(false);
    if (coinsShowInfo) setCoinsShowInfo(false);
    if (totalBalanceShowInfo) setTotalBalanceShowInfo(false);
    if (availableCreditsShowInfo) setAvailableCreditsShowInfo(false);
  };
  const { setMyProfileTooltipVisible, setTotalSteps, setCurrentStep } =
    useTooltips();
  return (
    <>
      {" "}
      <ScreenBGGradientView />
      <Header
        btnSearchTapped={() => {
          navigateToScreen(navigation, AppScreens.SearchEventWebScreen);
        }}
        btnWalletTapped={() => {}}
        btnStartTutorialTapped={() => {
          setMyProfileTooltipVisible(true);
          setTotalSteps(12);
          setCurrentStep(0);
        }}
        btnMessageTapped={() => {}}
        btnNotificationTapped={() => {}}
        btnProfileTapped={() => {}}
        displayTutorialButton={true}
      />
      <TouchableWithoutFeedback
        onPress={() => {
          closeTooltips();
        }}
      >
        <View style={[styles.container]}>
          {showSuccessModal && (
            <PurchaseSessionSuccessModal
              showModal={showSuccessModal}
              setShowModal={setShowSuccessModal}
              tokenData={userTokens}
              eventID={eventID}
              showLoader={showLoader}
            />
          )}
          <View
            style={{
              flex: 1,
            }}
          >
            <Text
              style={[
                deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  ? AppFontStyle.BOLD_ANYBODY_20
                  : AppFontStyle.BOLD_ANYBODY_32,
                {
                  color: AppColors.white,
                  marginBottom: 26,
                  marginTop:
                    deviceSize === DEVICE_SIZES.XS ||
                    deviceSize === DEVICE_SIZES.SM
                      ? 20
                      : 0,
                },
              ]}
            >
              My profile
            </Text>
            {deviceSize === DEVICE_SIZES.SM ||
            deviceSize === DEVICE_SIZES.XS ||
            deviceSize === DEVICE_SIZES.MD ||
            deviceSize === DEVICE_SIZES.LG ? (
              <ScrollView
                horizontal
                showsHorizontalScrollIndicator={false}
                style={{ flexGrow: 0 }}
              >
                <View
                  style={{
                    flexDirection: "row",
                    paddingBottom: 20,
                    gap: 12,
                  }}
                >
                  {tabTitles.map((title, index) => (
                    <TouchableOpacity
                      key={index}
                      onPress={() => setActiveTab(index)}
                      style={{
                        paddingVertical: 6,
                        paddingHorizontal: 8,
                        borderWidth: 1,
                        borderColor:
                          activeTab === index
                            ? AppColors.white
                            : AppColors.gray_BABABA,
                        borderRadius: 57,
                      }}
                    >
                      <Text
                        style={[
                          AppFontStyle.MEDIUM_ANYBODY_14,
                          {
                            color:
                              activeTab === index
                                ? AppColors.white
                                : AppColors.gray_BABABA,
                          },
                        ]}
                      >
                        {title}
                      </Text>
                    </TouchableOpacity>
                  ))}
                </View>
              </ScrollView>
            ) : null}
            <ScrollView
              ref={scrollViewRef}
              showsHorizontalScrollIndicator={false}
              showsVerticalScrollIndicator={false}
              style={{ flex: 1 }}
            >
              {deviceSize === DEVICE_SIZES.SM ||
              deviceSize === DEVICE_SIZES.XS ||
              deviceSize === DEVICE_SIZES.MD ||
              deviceSize === DEVICE_SIZES.LG ? (
                <View style={{}}>
                  {activeTab === 0 && (
                    <View style={{ gap: 20, marginBottom: 20 }}>
                      {/* done */}
                      <UserProfileWalkthrough
                        content={
                          <UserDetail
                            userProfileData={userProfileData}
                            setAddLinkPopup={setAddLinkPopup}
                            links={links}
                            isLoading={isLoading}
                            scrollViewRef={scrollViewRef}
                            setActiveTab={setActiveTab}
                          />
                        }
                      />
                      <GamesWalkthrough
                        setActiveTab={setActiveTab}
                        scrollViewRef={scrollViewRef}
                        content={
                          <MyGames
                            userProfileData={userProfileData}
                            userData={userData}
                            isLoading={isLoading}
                          />
                        }
                      />
                    </View>
                  )}
                  {/* done */}
                  {activeTab === 1 && (
                    <MyBelts
                      setCornfirmPurchaseBeltModal={
                        setCornfirmPurchaseBeltModal
                      }
                      setSaleBeltModal={setSaleBeltModal}
                      arrBeltMedalType={arrBeltMedalType}
                      setArrBeltMedalType={setArrBeltMedalType}
                      isLoading={isLoading}
                      setActiveTab={setActiveTab}
                      scrollViewRef={scrollViewRef}
                    />
                  )}
                  {activeTab === 2 && (
                    <View style={{ marginBottom: 20 }}>
                      {/* done */}
                      <MyGamesStatus
                        userProfileData={userProfileData}
                        isLoading={isLoading}
                        setActiveTab={setActiveTab}
                      />
                    </View>
                  )}
                  {activeTab === 3 && (
                    <View style={{ gap: 12, marginBottom: 20 }}>
                      <UserBalance
                        jumpToPurchaseToken={(isNavigate: false) => {
                          if (isNavigate) {
                            navigateToScreen(
                              navigation,
                              AppScreens.PurchaseScreen
                            );
                          }
                        }}
                        userProfileData={userProfileData}
                        totalShowInfo={totalShowInfo}
                        setTotalShowInfo={setTotalShowInfo}
                        coinsShowInfo={coinsShowInfo}
                        setCoinsShowInfo={setCoinsShowInfo}
                        accessToken={accessToken}
                        isLoading={isLoading}
                        setActiveTab={setActiveTab}
                        scrollViewRef={scrollViewRef}
                        totalBalanceShowInfo={totalBalanceShowInfo}
                        availableCreditsShowInfo={availableCreditsShowInfo}
                      />
                      <UserCredits
                        userProfileData={userProfileData}
                        setRedeemBalance={setRedeemBalance}
                        totalBalanceShowInfo={totalBalanceShowInfo}
                        setTotalBalanceShowInfo={setTotalBalanceShowInfo}
                        availableCreditsShowInfo={availableCreditsShowInfo}
                        setAvailableCreditsShowInfo={
                          setAvailableCreditsShowInfo
                        }
                        accessToken={accessToken}
                        isLoading={isLoading}
                        setActiveTab={setActiveTab}
                        scrollViewRef={scrollViewRef}
                        totalShowInfo={totalShowInfo}
                        coinsShowInfo={coinsShowInfo}
                      />
                      {/* <TotalTicketSold
                          userProfileData={userProfileData}
                          setShowInfo={setShowTotalTicketInfo}
                          showInfo={showTotalTicketInfo}
                          isLoading={isLoading}
                        /> */}
                    </View>
                  )}
                  {activeTab === 4 && (
                    <RankingTable
                      filteredRankingData={filteredRankingData}
                      showLoader={showLoader}
                      handleSearchInput={handleSearchInput}
                      searchEvent={searchEvent}
                      userData={userData}
                      isLoading={isLoading}
                      setActiveTab={setActiveTab}
                      scrollViewRef={scrollViewRef}
                    />
                  )}
                </View>
              ) : (
                <ScrollView
                  ref={scrollViewRef}
                  showsHorizontalScrollIndicator={false}
                  showsVerticalScrollIndicator={false}
                  style={{ flex: 1 }}
                >
                  <View
                    style={{
                      flexDirection: "row",
                      gap: 30,
                      alignItems: "stretch",
                      ...(showTotalTicketInfo ||
                      totalShowInfo ||
                      coinsShowInfo ||
                      totalBalanceShowInfo ||
                      availableCreditsShowInfo
                        ? { zIndex: -1 }
                        : {}),
                    }}
                  >
                    <UserProfileWalkthrough
                      content={
                        <UserDetail
                          userProfileData={userProfileData}
                          setAddLinkPopup={setAddLinkPopup}
                          links={links}
                          isLoading={isLoading}
                          scrollViewRef={scrollViewRef}
                          setActiveTab={setActiveTab}
                        />
                      }
                    />
                    <MyBelts
                      setCornfirmPurchaseBeltModal={
                        setCornfirmPurchaseBeltModal
                      }
                      setSaleBeltModal={setSaleBeltModal}
                      arrBeltMedalType={arrBeltMedalType}
                      setArrBeltMedalType={setArrBeltMedalType}
                      isLoading={isLoading}
                      setActiveTab={setActiveTab}
                      scrollViewRef={scrollViewRef}
                    />
                  </View>
                  <Separator
                    color={AppColors.gray_1E1E1E}
                    height={1}
                    marginTop={20}
                    marginBottom={20}
                    marginHorizontal={0}
                  />
                  <View
                    style={{
                      flexDirection: "row",
                      gap: 30,
                      alignItems: "stretch",
                      ...(showTotalTicketInfo ||
                      totalShowInfo ||
                      coinsShowInfo ||
                      totalBalanceShowInfo ||
                      availableCreditsShowInfo
                        ? { zIndex: -1 }
                        : {}),
                    }}
                  >
                    <MyGamesStatus
                      userProfileData={userProfileData}
                      isLoading={isLoading}
                      setActiveTab={setActiveTab}
                    />
                    <GamesWalkthrough
                      setActiveTab={setActiveTab}
                      scrollViewRef={scrollViewRef}
                      content={
                        <MyGames
                          userProfileData={userProfileData}
                          userData={userData}
                          isLoading={isLoading}
                        />
                      }
                    />
                  </View>
                  <Separator
                    color={AppColors.gray_1E1E1E}
                    height={1}
                    marginTop={20}
                    marginBottom={20}
                    marginHorizontal={0}
                  />
                  <View
                    style={{
                      flexDirection: "row",
                      gap: 30,
                      marginBottom: 20,
                      zIndex: -1,
                      alignItems: "stretch",
                    }}
                  >
                    <UserBalance
                      jumpToPurchaseToken={(isNavigate: false) => {
                        if (isNavigate) {
                          navigateToScreen(
                            navigation,
                            AppScreens.PurchaseScreen
                          );
                        }
                      }}
                      userProfileData={userProfileData}
                      totalShowInfo={totalShowInfo}
                      setTotalShowInfo={setTotalShowInfo}
                      coinsShowInfo={coinsShowInfo}
                      setCoinsShowInfo={setCoinsShowInfo}
                      accessToken={accessToken}
                      isLoading={isLoading}
                      setActiveTab={setActiveTab}
                      scrollViewRef={scrollViewRef}
                      totalBalanceShowInfo={totalBalanceShowInfo}
                      availableCreditsShowInfo={availableCreditsShowInfo}
                    />
                    <UserCredits
                      userProfileData={userProfileData}
                      setRedeemBalance={setRedeemBalance}
                      totalBalanceShowInfo={totalBalanceShowInfo}
                      setTotalBalanceShowInfo={setTotalBalanceShowInfo}
                      availableCreditsShowInfo={availableCreditsShowInfo}
                      setAvailableCreditsShowInfo={setAvailableCreditsShowInfo}
                      accessToken={accessToken}
                      isLoading={isLoading}
                      setActiveTab={setActiveTab}
                      scrollViewRef={scrollViewRef}
                      totalShowInfo={totalShowInfo}
                      coinsShowInfo={coinsShowInfo}
                    />
                  </View>
                  {/* <View>
                    <TotalTicketSold
                      userProfileData={userProfileData}
                      setShowInfo={setShowTotalTicketInfo}
                      showInfo={showTotalTicketInfo}
                      isLoading={isLoading}
                    />
                  </View> */}
                  <Separator
                    color={AppColors.gray_1E1E1E}
                    height={3}
                    marginTop={20}
                    marginBottom={20}
                    marginHorizontal={0}
                  />
                  <RankingTable
                    filteredRankingData={filteredRankingData}
                    showLoader={showLoader}
                    handleSearchInput={handleSearchInput}
                    searchEvent={searchEvent}
                    userData={userData}
                    isLoading={isLoading}
                    setActiveTab={setActiveTab}
                    scrollViewRef={scrollViewRef}
                  />
                </ScrollView>
              )}
            </ScrollView>
            {/* AddEventDetails */}
            {
              <AddEventDetails
                showModal={createEvent}
                setShowModal={setCreateEvent}
                setCompetitorModel={setCompetitorModel}
                setData={setApiData}
                isUpdate={false}
                userData={userData}
              />
            }
            {/* CompetitorsModal */}
            {
              <CompetitorsModal
                showModal={competitorModel}
                setShowModal={setCompetitorModel}
                apiData={apiData}
                setApiData={setApiData}
                accessToken={accessToken}
                setRefreshAPICall={setRefreshAPICall}
              />
            }
            {/* BuyBeltaModal */}
            {buyBeltaModal && (
              <BuyBeltaModal
                showModal={buyBeltaModal}
                setShowModal={setBuyBeltaModal}
                paymentAPIData={async (apisData) => {
                  let result = await WebBrowser.openAuthSessionAsync(
                    apisData.url,
                    "http://ww25.your-domain.com/"
                  );
                  setResult(result);

                  setTimeout(() => {
                    WebBrowser.maybeCompleteAuthSession();
                  }, 5000);
                }}
                selectedBelt={(data) => {
                  setCornfirmPurchaseBeltModal(true);
                }}
              />
            )}
            {/* CornfirmPurchaseBeltModal */}
            {cornfirmPurchaseBeltModal && (
              <CornfirmPurchaseBeltModal
                accessToken={accessToken}
                numberOfBelts={numberOfBelts}
                setArrBeltMedalType={setArrBeltMedalType}
                arrBeltMedalType={arrBeltMedalType}
                showModal={cornfirmPurchaseBeltModal}
                setRefreshAPICall={setRefreshAPICall}
                userBalanceData={userBalanceData}
                setShowModal={setCornfirmPurchaseBeltModal}
                dataSelectedBelt={arrBeltMedalType.find(
                  (item) => item.isSelected
                )}
                selectedBelt={(data) => {
                  setBeltPurchaseSuccessModal(true);
                }}
                jumpToPurchaseToken={(isNavigate: false) => {
                  if (isNavigate) {
                    navigateToScreen(navigation, AppScreens.PurchaseScreen);
                  }
                }}
              />
            )}
            {/* PaymentScreen */}
            {showPaymentScreen && (
              <PaymentScreen
                showModal={showPaymentScreen}
                setShowModal={setShowPaymentScreen}
                paymentSuccess={(data) => {
                  setShowPurchaseSuccess(true);
                }}
              />
            )}
            {/* BeltPurchaseSuccessModal  */}
            {beltPurchaseSuccessModal && (
              <BeltPurchaseSuccessModal
                setSaleBeltModal={setSaleBeltModal}
                arrBeltMedalType={arrBeltMedalType}
                showModal={beltPurchaseSuccessModal}
                setShowModal={setBeltPurchaseSuccessModal}
                numberOfBelts={numberOfBelts}
                dataBuyBelt={arrBeltMedalType.find((item) => item.isSelected)}
                backProfileTapped={() => {
                  reloadAPIs();
                }}
              />
            )}
            {/* SaleBeltModal */}
            {saleBeltModal && (
              <SaleBeltModal
                showModal={saleBeltModal}
                sellBeltsData={
                  arrBeltMedalType.filter((item) => item.isSelected)[0]
                }
                setArrBeltMedalType={setArrBeltMedalType}
                setShowModal={setSaleBeltModal}
                userData={userData}
                numberOfBelts={numberOfBelts}
                accessToken={accessToken}
                setRefreshAPICall={setRefreshAPICall}
                confirmSuccess={(data) => {
                  setSaleBeltData(data);
                  setSaleBeltModal(false);
                  setShowPurchaseSuccess(true);
                }}
              />
            )}
            {redeemBalance && (
              <RedeemCreditsModal
                showModal={redeemBalance}
                setShowModal={setRedeemBalance}
                userProfileData={userProfileData}
                accessToken={accessToken}
                setRefreshAPICall={setRefreshAPICall}
              />
            )}
            {finalWarningPopup && (
              <FinalWarning
                showModal={finalWarningPopup}
                setShowModal={setFinalWarningPopup}
              />
            )}
            {addLinkPopup && (
              <AddSocialLink
                links={links}
                handleUpdateLinks={handleUpdateLinks}
                handleLinkChange={handleLinkChange}
                showModal={addLinkPopup}
                setShowModal={setAddLinkPopup}
              />
            )}
            {/* VerificationModal */}
            {showVerification && (
              <VerificationModal
                showModal={showVerification}
                setShowModal={setShowVerification}
                pinVerifySuccess={(data) => {
                  setShowPurchaseSuccess(true);
                }}
              />
            )}
            {/* PurchaseSuccess */}
            {showPurchaseSuccess && (
              <PurchaseSuccess
                responseData={saleBeltData}
                showModal={showPurchaseSuccess}
                setShowModal={setShowPurchaseSuccess}
                checkScreen={enumPurchaseSuccess.saleSuccess}
                showLoader={showLoader}
              />
            )}
          </View>
        </View>
      </TouchableWithoutFeedback>
      <ProWalkthrough />
    </>
  );
};

export default MyProfileWebScreen;

const useStyles = CreateResponsiveStyle(
  {
    container: {
      flex: 1,
      paddingHorizontal: "3.5%",
      paddingTop: "2.5%",
    },
  },
  {
    [DEVICE_SIZES.MD]: {},
    [DEVICE_SIZES.LG]: {},
    [DEVICE_SIZES.SM]: {
      // container: {
      //   paddingHorizontal: 0,
      //   paddingTop: 0,
      // },
    },
    [DEVICE_SIZES.XS]: {
      // container: {
      //   paddingHorizontal: 0,
      //   paddingTop: 0,
      // },
    },
  }
);
